module.exports = __webpack_public_path__ + "static/media/fotobox_logo.56df1db0.png";